import { makeStyles } from '@material-ui/core';
import { neutral } from '../../shared/styles/colors';

export default makeStyles(() => ({
  board: ({ totalColumns, hasAutoAccept }: Props) => ({
    backgroundColor: neutral[10],
    flex: '1 1 1px',
    height: '100%',
    padding: '0.75rem',
    width: '100%',
    display: 'grid',
    gridTemplateRows: '100%',
    overflow: 'auto',
    gridTemplateColumns: `repeat(${totalColumns}, minmax(6rem, ${
      hasAutoAccept ? '35rem' : '1fr'
    }))`,
    gap: '0.5rem',
    justifyContent: 'center',
  }),
  root: {
    flexDirection: 'column',
    display: 'flex',
    height: '100%',
  },
  swipeableViewsRoot: {
    height: '100%',
    '& div.react-swipeable-view-container': {
      height: '100%',
    },
  },
}));

interface Props {
  totalColumns: number;
  hasAutoAccept: boolean;
}
